import script from "./DelayOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./DelayOrder.vue?vue&type=script&lang=ts&setup=true"

import "./DelayOrder.vue?vue&type=style&index=0&id=d454268e&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d454268e"]])

export default __exports__